import RuntimeConfig from '../../../routes/runtimeConfig';

/**
 * Is this the PRODUCTION environment
 * @returns {boolean}
 */
export const isProduction = (): boolean => !!PRODUCTION;

/**
 * Turn a url into an environment specific url
 * @param {string} url
 * @param {string} prefix
 * @returns {string}
 */

export const envUrl = (url: string, prefix: string = '/mbs'): string => {
  // Calling this function with m4b as the prefix is pointless and wrong, but it happened.
  // We cope with that here until the offending code is removed
  const finalPrefix = prefix === '/m4b' ? prefix : RuntimeConfig.appRootUrlPath;

  return finalPrefix + url;
};
